module.exports = __webpack_public_path__ + "static/media/OneXtelLogo.cccf7638.png";